import { Injectable } from '@angular/core';

function _window(): any {
    return window; // return the global native browser window object
}

function _document(): any {
    return document; // return the global native browser document object
}

@Injectable({providedIn: "root"})
export class TfWindowRefService {
    get nativeWindow(): any {
        return _window();
    }

    get nativeDocument(): any {
        return _document();
    }

}
